import React from "react";
import { LoginHeader } from "./LoginHeader";

const LoginContainer = ({ children }) => {
    return (
        <div
            style={{
                minHeight: "100vh",
                width: "100%",
                backgroundColor: "#5f4dee",
            }}>
            <LoginHeader />
            {children}
        </div>
    );
};

export { LoginContainer };
